export default "__VITE_ASSET__88b56b21__"